import React, { useContext, useEffect } from "react";
import { useAuth } from "../../Context/useAuth";
import { useOrder } from "../../Context/useOrder";
import { observer } from "mobx-react";
import { dataContext } from "../../Context/contextProvider";
import { Button } from "react-bootstrap";
import { LogoutRequest } from "../../Models/LogoutRequest";

const LogoutPage = observer(() => {
  const { logout, isAuthenticated, getDeviceId } = useAuth();
  const { setCurrentOrder } = useOrder();
  const dataStore = useContext(dataContext);
  useEffect(() => {
    if (!isAuthenticated()) {
      return;
    }
    const logoutModel: LogoutRequest = {
      serverUrl: dataStore.serverUrl || "",
      dbKey: dataStore.dbKey || "",
      deviceId: getDeviceId() || "",
      username: dataStore?.userInfo?.username || "",
    };
    logout(logoutModel);
    setCurrentOrder(null);
  }, [logout, isAuthenticated, setCurrentOrder, dataStore, getDeviceId]);

  return (
    <div className="d-flex flex-row align-items-center" style={{ minHeight: "100vh" }}>
      <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-8 offset-sm-2 col-12 d-flex flex-column">
        <h4 className="text-center">
          You have been logged out
          <br />
        </h4>
        <div className="text-center mt-5">
          <Button
            variant="outline-secondary"
            title="Login"
            onClick={() => {
              window.location.href = "/login";
            }}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
});

export default LogoutPage;
